import { gql } from '@apollo/client';

export const CREATE_INSTRUCTION_TYPE = gql`
  mutation CreateInstructionType($data: CreateInstructionTypeInput!) {
    createInstructionType(data: $data) {
      message
      status
    }
  }
`;

export const UPDATE_INSTRUCTION_TYPE = gql`
  mutation UpdateInstructionType($id: ID!, $data: UpdateInstructionTypeInput!) {
    updateInstructionType(id: $id, data: $data) {
      status
      message
    }
  }
`;

export const DELETE_INSTRUCTION_TYPE = gql`
  mutation DeleteInstructionType($id: ID!) {
    deleteInstructionType(id: $id) {
      status
      message
    }
  }
`;

export const MOVE_INSTRUCTION_TYPE = gql`
  mutation MoveInstructionType($data: MoveInstructionTypeInput!) {
    moveInstructionType(data: $data) {
      status
      message
    }
  }
`;
